module.exports = __webpack_public_path__ + "img/06-1.4d5ac335.png";